import { render, staticRenderFns } from "./DraftPriceAgreementStatus.vue?vue&type=template&id=be843fd6&"
import script from "./DraftPriceAgreementStatus.vue?vue&type=script&lang=js&"
export * from "./DraftPriceAgreementStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports